/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointMapLocation } from './DataPointMapLocation';
import {
    DataPointMapLocationFromJSON,
    DataPointMapLocationFromJSONTyped,
    DataPointMapLocationToJSON,
    DataPointMapLocationToJSONTyped,
} from './DataPointMapLocation';

/**
 * Custom serializer that returns map data.
 * @export
 * @interface EmissionRecordMap
 */
export interface EmissionRecordMap {
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordMap
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordMap
     */
    detectedRate: number;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordMap
     */
    concentration: number;
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordMap
     */
    plumeImage: string;
    /**
     * 
     * @type {DataPointMapLocation}
     * @memberof EmissionRecordMap
     */
    location: DataPointMapLocation;
    /**
     * 
     * @type {Date}
     * @memberof EmissionRecordMap
     */
    detectionTimestamp: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmissionRecordMap
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordMap
     */
    providerId: string;
}

/**
 * Check if a given object implements the EmissionRecordMap interface.
 */
export function instanceOfEmissionRecordMap(value: object): value is EmissionRecordMap {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('detectedRate' in (value as Record<string, any>)) && !('detected_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectedRate'] === undefined && (value as Record<string, any>)['detected_rate'] === undefined)) return false;
    if (!('concentration' in value) || value['concentration'] === undefined) return false;
    if ((!('plumeImage' in (value as Record<string, any>)) && !('plume_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['plumeImage'] === undefined && (value as Record<string, any>)['plume_image'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectionTimestamp' in (value as Record<string, any>)) && !('detection_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionTimestamp'] === undefined && (value as Record<string, any>)['detection_timestamp'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('providerId' in (value as Record<string, any>)) && !('provider_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['providerId'] === undefined && (value as Record<string, any>)['provider_id'] === undefined)) return false;
    return true;
}

export function EmissionRecordMapFromJSON(json: any): EmissionRecordMap {
    return EmissionRecordMapFromJSONTyped(json, false);
}

export function EmissionRecordMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionRecordMap {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'detectedRate': json['detected_rate'],
        'concentration': json['concentration'],
        'plumeImage': json['plume_image'],
        'location': DataPointMapLocationFromJSON(json['location']),
        'detectionTimestamp': (new Date(json['detection_timestamp'])),
        'createdAt': (new Date(json['created_at'])),
        'providerId': json['provider_id'],
    };
}

export function EmissionRecordMapToJSON(json: any): EmissionRecordMap {
    return EmissionRecordMapToJSONTyped(json, false);
}

export function EmissionRecordMapToJSONTyped(value?: EmissionRecordMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'detected_rate': value['detectedRate'],
        'concentration': value['concentration'],
        'plume_image': value['plumeImage'],
        'location': DataPointMapLocationToJSON(value['location']),
        'detection_timestamp': value['detectionTimestamp'].toISOString(),
        'created_at': value['createdAt'].toISOString(),
        'provider_id': value['providerId'],
    };
}

